export default "__VITE_ASSET__DLLRM7Bo__"